/* =========================================================
   ZIPLINE THEME - AJAX CART + SHOPFLO HANDOFF
   Buy Now      -> handleFloBuyNowBtn(event)
   Cart / Bag   -> handleFloCartBtn()
   Checkout     -> handleFloCheckoutBtn()
   Add To Cart  -> /cart/add.js, then handleFloCartBtn()
   ========================================================= */

(function() {
  'use strict';

  /* ---------------------------------------------------------
     0. SHOPFLO BRIDGE
     Shopflo's script may load after the theme, so every call is
     resolved lazily and falls back to native behaviour if the
     handler never shows up.
     --------------------------------------------------------- */

  const FLO = {
    BUY_NOW: 'handleFloBuyNowBtn',
    CART: 'handleFloCartBtn',
    CHECKOUT: 'handleFloCheckoutBtn'
  };

  function floFn(name) {
    return typeof window[name] === 'function' ? window[name] : null;
  }

  // Waits briefly for a Shopflo handler to appear (script may still be loading).
  function whenFloReady(name, timeout) {
    timeout = timeout || 3000;
    return new Promise(function(resolve) {
      const existing = floFn(name);
      if (existing) return resolve(existing);

      const start = Date.now();
      const poll = setInterval(function() {
        const fn = floFn(name);
        if (fn) {
          clearInterval(poll);
          resolve(fn);
        } else if (Date.now() - start > timeout) {
          clearInterval(poll);
          resolve(null);
        }
      }, 100);
    });
  }

  /**
   * Invoke a Shopflo handler.
   * @param {string} name     one of FLO.*
   * @param {Event}  event    original DOM event (Buy Now needs it)
   * @param {Function} fallback  runs only if the handler never loads
   */
  function callFlo(name, event, fallback) {
    return whenFloReady(name).then(function(fn) {
      if (!fn) {
        console.warn('[zipline] ' + name + ' unavailable, using fallback.');
        if (typeof fallback === 'function') fallback();
        return false;
      }
      try {
        // handleFloBuyNowBtn expects the event; the others take no args.
        if (name === FLO.BUY_NOW) {
          fn(event);
        } else {
          fn();
        }
        return true;
      } catch (err) {
        console.error('[zipline] ' + name + ' threw:', err);
        if (typeof fallback === 'function') fallback();
        return false;
      }
    });
  }

  /* ---------------------------------------------------------
     1. Toast Notification Container
     --------------------------------------------------------- */
  function getOrCreateToastContainer() {
    let container = document.getElementById('zipline-toast-container');
    if (!container) {
      container = document.createElement('div');
      container.id = 'zipline-toast-container';
      container.setAttribute('style', [
        'position: fixed',
        'bottom: 24px',
        'right: 24px',
        'z-index: 9999999',
        'display: flex',
        'flex-direction: column',
        'gap: 10px',
        'pointer-events: none',
        'max-width: 90vw',
        'width: 380px'
      ].join('; '));
      document.body.appendChild(container);
    }
    return container;
  }

  /* ---------------------------------------------------------
     2. Show Toast Notification
     --------------------------------------------------------- */
  window.ziplineShowToast = function(message, isSuccess = true) {
    const container = getOrCreateToastContainer();
    const toast = document.createElement('div');
    toast.className = 'zp-toast';
    toast.setAttribute('style', [
      'background: #182330',
      'color: #FFFFFF',
      'border-left: 4px solid ' + (isSuccess ? '#2E7D47' : '#D32F2F'),
      'box-shadow: 0 10px 30px rgba(0,0,0,0.3)',
      'padding: 14px 18px',
      'border-radius: 8px',
      'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      'font-size: 14px',
      'font-weight: 500',
      'line-height: 1.5',
      'display: flex',
      'align-items: center',
      'justify-content: space-between',
      'gap: 12px',
      'pointer-events: auto',
      'transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
      'transform: translateY(20px)',
      'opacity: 0'
    ].join('; '));

    toast.innerHTML = '<span></span><button type="button" style="background:none;border:none;color:#94A3B8;cursor:pointer;font-size:18px;padding:0;line-height:1;" aria-label="Close">&times;</button>';
    toast.querySelector('span').textContent = message;

    const closeBtn = toast.querySelector('button');
    closeBtn.addEventListener('click', function() {
      toast.style.opacity = '0';
      toast.style.transform = 'translateY(20px)';
      setTimeout(() => toast.remove(), 300);
    });

    container.appendChild(toast);

    requestAnimationFrame(() => {
      toast.style.transform = 'translateY(0)';
      toast.style.opacity = '1';
    });

    setTimeout(function() {
      if (toast.parentElement) {
        toast.style.opacity = '0';
        toast.style.transform = 'translateY(20px)';
        setTimeout(() => toast.remove(), 300);
      }
    }, 3500);
  };

  /* ---------------------------------------------------------
     3. Update Cart Badges across Header
     --------------------------------------------------------- */
  window.ziplineUpdateCartCount = function(count) {
    const badges = document.querySelectorAll('.cart-count-bubble span, #cartCountBadge, [data-cart-count]');
    badges.forEach(b => {
      b.textContent = count;
    });

    const bubbles = document.querySelectorAll('.cart-count-bubble');
    bubbles.forEach(b => {
      if (count > 0) {
        b.classList.remove('hidden');
        b.style.display = 'flex';
      }
    });
  };

  // Pull the live count and sync the badge.
  window.ziplineSyncCartCount = function() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(r => r.json())
      .then(cart => {
        if (cart && typeof cart.item_count === 'number') {
          window.ziplineUpdateCartCount(cart.item_count);
        }
        return cart;
      })
      .catch(function() { return null; });
  };

  /* ---------------------------------------------------------
     4. Native drawer refresh — FALLBACK ONLY
     Used when Shopflo's cart handler isn't available.
     --------------------------------------------------------- */
  window.ziplineRefreshCartDrawer = function() {
    const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
    fetch(cartUrl + '?section_id=cart-drawer')
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newDrawer = doc.querySelector('cart-drawer');
        const currentDrawer = document.querySelector('cart-drawer');

        if (currentDrawer && newDrawer) {
          currentDrawer.innerHTML = newDrawer.innerHTML;
          currentDrawer.classList.remove('is-empty');

          const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
          if (overlay) {
            overlay.addEventListener('click', () => currentDrawer.close());
          }

          if (typeof currentDrawer.open === 'function') {
            currentDrawer.open();
          } else {
            currentDrawer.classList.add('active', 'animate');
            document.body.classList.add('overflow-hidden');
          }
        }
      })
      .catch(err => {
        console.error('Error refreshing cart drawer:', err);
      });
  };

  /* ---------------------------------------------------------
     5. FLOW 2 — CART
     Opens the Shopflo cart instead of navigating to /cart.
     --------------------------------------------------------- */
  window.ziplineOpenCart = function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return callFlo(FLO.CART, event, function() {
      // Shopflo missing: fall back to the theme drawer.
      window.ziplineRefreshCartDrawer();
    });
  };

  /* ---------------------------------------------------------
     6. FLOW 3 — CHECKOUT
     Opens Shopflo checkout instead of /checkout.
     --------------------------------------------------------- */
  window.ziplineCheckout = function(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    return callFlo(FLO.CHECKOUT, event, function() {
      window.location.href = '/checkout';
    });
  };

  /* ---------------------------------------------------------
     7. FLOW 1 — BUY NOW
     Hands the click straight to Shopflo. No /cart/<id>:<qty>
     permalink, no Shopify checkout redirect.
     --------------------------------------------------------- */
  window.ziplineBuyNow = function(event, variantId, quantity) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    // Expose the selected variant so the handler can read it if it needs to.
    if (variantId) {
      window.ziplineBuyNowContext = {
        variantId: Number(variantId),
        quantity: Number(quantity || 1)
      };
    }

    return callFlo(FLO.BUY_NOW, event, function() {
      if (variantId) {
        window.location.href = '/cart/' + variantId + ':' + (quantity || 1);
      }
    });
  };

  /* ---------------------------------------------------------
     8. ADD TO CART -> /cart/add.js -> handleFloCartBtn()
     --------------------------------------------------------- */
  window.ziplineAddToCart = function(variantId, quantity, btnElement, productTitle) {
    quantity = quantity || 1;
    productTitle = productTitle || 'Item';

    let origText = '';
    if (btnElement) {
      origText = btnElement.innerHTML;
      btnElement.disabled = true;
      btnElement.innerHTML = '<span>Adding...</span>';
    }

    function doActualAdd(vId) {
      const payload = {
        id: Number(vId),
        quantity: Number(quantity)
      };

      return fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify(payload)
      })
      .then(function(res) {
        if (!res.ok) {
          return res.json().then(function(err) {
            throw new Error(err.description || err.message || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function(addedItem) {
        if (btnElement) {
          btnElement.innerHTML = '<span>Added ✓</span>';
          setTimeout(function() {
            btnElement.innerHTML = origText;
            btnElement.disabled = false;
          }, 1800);
        }

        window.ziplineShowToast('Added "' + (addedItem.title || productTitle) + '" to your bag! ✓', true);

        // Keep the header badge honest, then hand off to Shopflo.
        return window.ziplineSyncCartCount().then(function() {
          return window.ziplineOpenCart(null);
        });
      })
      .catch(function(err) {
        if (btnElement) {
          btnElement.innerHTML = origText;
          btnElement.disabled = false;
        }
        window.ziplineShowToast(err.message || 'Error adding to cart. Please try again.', false);
      });
    }

    if (!variantId || variantId === 'null' || variantId === 'undefined') {
      if (btnElement) {
        btnElement.innerHTML = origText;
        btnElement.disabled = false;
      }
      window.ziplineShowToast('Please select an option before adding to cart.', false);
      return Promise.resolve();
    }

    return doActualAdd(variantId);
  };

  /* ---------------------------------------------------------
     9. Card Variant Swatch Switcher
     --------------------------------------------------------- */
  window.ziplineSwitchCardSwatch = function(swatchEl, event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }
    if (!swatchEl) return;
    const card = swatchEl.closest('.zp-card') || swatchEl.closest('.zp-product-card');
    if (!card) return;

    const swatches = card.querySelectorAll('.zp-card__swatch, .zp-swatch-btn');
    swatches.forEach(s => s.classList.remove('is-active'));
    swatchEl.classList.add('is-active');

    card.classList.add('has-swatch-selected');

    // 1. Swap image smoothly
    const imgUrl = swatchEl.getAttribute('data-img-url');
    const primImg = card.querySelector('.zp-card__img--primary') || card.querySelector('.zp-product-card__img') || card.querySelector('img.zp-card__img');
    const secImg = card.querySelector('.zp-card__img--secondary');

    if (secImg) {
      secImg.style.opacity = '0';
      secImg.style.visibility = 'hidden';
      secImg.style.pointerEvents = 'none';
    }

    if (imgUrl && primImg) {
      primImg.style.transition = 'opacity 0.2s ease, transform 0.3s ease';
      primImg.style.opacity = '0.4';
      primImg.removeAttribute('srcset');
      primImg.src = imgUrl;

      primImg.onload = function() {
        primImg.style.opacity = '1';
      };
      setTimeout(function() {
        primImg.style.opacity = '1';
      }, 250);
    }

    // 2. Update variant ID everywhere, including the Buy Now button
    const varId = swatchEl.getAttribute('data-variant-id');
    if (varId) {
      const idInput = card.querySelector('input[name="id"]');
      if (idInput) idInput.value = varId;

      const buyBtn = card.querySelector('.zp-card__btn--buy') || card.querySelector('.zp-btn-card--buy');
      if (buyBtn) {
        // No permalink href any more — Shopflo owns this click.
        buyBtn.setAttribute('data-variant-id', varId);
        if (buyBtn.tagName === 'A') buyBtn.removeAttribute('href');
      }

      const cartBtn = card.querySelector('.zp-card__btn--cart') || card.querySelector('.zp-btn-card--cart');
      if (cartBtn) {
        cartBtn.setAttribute('data-variant-id', varId);
      }
    }

    // 3. Update Price
    const price = swatchEl.getAttribute('data-price');
    if (price) {
      const priceEl = card.querySelector('.zp-card__price-current') || card.querySelector('.zp-price-current');
      if (priceEl) priceEl.textContent = price;
    }

    const compPrice = swatchEl.getAttribute('data-compare-price');
    const compEl = card.querySelector('.zp-card__price-compare') || card.querySelector('.zp-price-original');
    if (compEl) {
      if (compPrice) {
        compEl.textContent = compPrice;
        compEl.style.display = 'inline-block';
      } else {
        compEl.style.display = 'none';
      }
    }

    // 4. Update availability
    const isAvail = swatchEl.getAttribute('data-available') !== 'false';
    const cartBtn = card.querySelector('.zp-card__btn--cart') || card.querySelector('.zp-btn-card--cart');
    if (cartBtn) {
      if (!isAvail) {
        cartBtn.textContent = 'Sold Out';
        cartBtn.disabled = true;
      } else {
        cartBtn.textContent = 'Add To Cart';
        cartBtn.disabled = false;
      }
    }
  };

  /* ---------------------------------------------------------
     10. Selectors the three flows listen on
     Add your own theme selectors here rather than in the
     listener below.
     --------------------------------------------------------- */
  const SELECTORS = {
    buyNow: [
      '.zp-card__btn--buy',
      '.zp-btn-card--buy',
      '.zp-pdp__btn-buy',
      '[data-flo-buy-now]',
      '.shopify-payment-button__button'
    ].join(', '),

    cart: [
      '#cart-icon-bubble',
      '.zp-header__cart',
      '[data-flo-cart]',
      'a[href="/cart"]',
      'a[href$="/cart"]'
    ].join(', '),

    checkout: [
      'button[name="checkout"]',
      'input[name="checkout"]',
      '#CartDrawer-Checkout',
      '#checkout',
      '.zp-cart__checkout',
      '[data-flo-checkout]',
      'a[href="/checkout"]',
      'a[href$="/checkout"]'
    ].join(', ')
  };

  function closestMatch(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  function readVariant(el) {
    if (!el) return null;
    const direct = el.getAttribute('data-variant-id');
    if (direct) return direct;
    const scope = el.closest('form') || el.closest('.zp-card') || el.closest('.zp-pdp');
    const input = scope && scope.querySelector('[name="id"]');
    return input ? input.value : null;
  }

  function readQuantity(el) {
    const scope = el.closest('form') || el.closest('.zp-card') || el.closest('.zp-pdp');
    const input = scope && scope.querySelector('[name="quantity"]');
    const qty = input ? parseInt(input.value, 10) : 1;
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  /* ---------------------------------------------------------
     11. One delegated click listener for all three flows.
     Capture phase so it beats Dawn's own handlers.
     --------------------------------------------------------- */
  document.addEventListener('click', function(e) {

    // --- FLOW 1: Buy Now ---
    const buyEl = closestMatch(e.target, SELECTORS.buyNow);
    if (buyEl) {
      window.ziplineBuyNow(e, readVariant(buyEl), readQuantity(buyEl));
      return;
    }

    // --- FLOW 3: Checkout ---
    const checkoutEl = closestMatch(e.target, SELECTORS.checkout);
    if (checkoutEl) {
      window.ziplineCheckout(e);
      return;
    }

    // --- FLOW 2: Cart ---
    const cartEl = closestMatch(e.target, SELECTORS.cart);
    if (cartEl) {
      window.ziplineOpenCart(e);
      return;
    }

    // --- Swatches ---
    const swatch = closestMatch(e.target, '.zp-card__swatch, .zp-swatch-btn');
    if (swatch) {
      window.ziplineSwitchCardSwatch(swatch, e);
    }
  }, true);

  document.addEventListener('mouseover', function(e) {
    const swatch = closestMatch(e.target, '.zp-card__swatch, .zp-swatch-btn');
    if (swatch && !swatch.classList.contains('is-active')) {
      window.ziplineSwitchCardSwatch(swatch);
    }
  });

  /* ---------------------------------------------------------
     12. Form submit handler
     Add-to-cart forms go through add.js -> handleFloCartBtn().
     Checkout forms go straight to handleFloCheckoutBtn().
     --------------------------------------------------------- */
  document.addEventListener('submit', function(e) {
    const form = e.target;
    if (!form) return;

    const isCartForm = form.classList.contains('zp-card__form') ||
                       form.classList.contains('zp-pdp__form') ||
                       form.id === 'pdpForm';

    // A cart page form submitted via its checkout button.
    const submitter = e.submitter;
    if (submitter && closestMatch(submitter, SELECTORS.checkout)) {
      e.preventDefault();
      window.ziplineCheckout(e);
      return;
    }

    if (!isCartForm) return;

    e.preventDefault();

    const variantInput = form.querySelector('[name="id"]');
    const qtyInput = form.querySelector('[name="quantity"]');
    const submitBtn = form.querySelector('button[type="submit"]') ||
                      form.querySelector('.zp-pdp__btn-cart') ||
                      form.querySelector('.zp-card__btn--cart');

    const varId = variantInput ? variantInput.value : null;
    const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;

    let title = '';
    const card = form.closest('.zp-card') || form.closest('.zp-pdp');
    if (card) {
      const titleEl = card.querySelector('.zp-card__title, .zp-pdp__title');
      if (titleEl) title = titleEl.textContent.trim();
    }

    window.ziplineAddToCart(varId, isNaN(qty) ? 1 : qty, submitBtn, title);
  }, true);

  /* ---------------------------------------------------------
     13. Strip Buy Now permalinks that were rendered by Liquid,
     so a mis-timed click can never leak to Shopify checkout.
     --------------------------------------------------------- */
  function neutralizeBuyNowLinks(root) {
    (root || document).querySelectorAll('a.zp-card__btn--buy, a.zp-btn-card--buy, a.zp-pdp__btn-buy').forEach(function(a) {
      const href = a.getAttribute('href') || '';
      const match = href.match(/\/cart\/(\d+):(\d+)/);
      if (match && !a.getAttribute('data-variant-id')) {
        a.setAttribute('data-variant-id', match[1]);
      }
      if (href) {
        a.setAttribute('data-original-href', href);
        a.removeAttribute('href');
        a.style.cursor = 'pointer';
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { neutralizeBuyNowLinks(); });
  } else {
    neutralizeBuyNowLinks();
  }

  // Re-run after section renders / drawer refreshes.
  document.addEventListener('shopify:section:load', function(e) {
    neutralizeBuyNowLinks(e.target);
  });
  window.ziplineNeutralizeBuyNowLinks = neutralizeBuyNowLinks;

})();





// /* =========================================================
//    ZIPLINE THEME - FOOLPROOF AJAX CART & DRAWER SYSTEM
//    Handles seamless Add to Cart, Cart Drawer updates & Notifications
//    ========================================================= */

// (function() {
//   'use strict';

//   // 1. Toast Notification Container
//   function getOrCreateToastContainer() {
//     let container = document.getElementById('zipline-toast-container');
//     if (!container) {
//       container = document.createElement('div');
//       container.id = 'zipline-toast-container';
//       container.setAttribute('style', [
//         'position: fixed',
//         'bottom: 24px',
//         'right: 24px',
//         'z-index: 9999999',
//         'display: flex',
//         'flex-direction: column',
//         'gap: 10px',
//         'pointer-events: none',
//         'max-width: 90vw',
//         'width: 380px'
//       ].join('; '));
//       document.body.appendChild(container);
//     }
//     return container;
//   }

//   // 2. Show Toast Notification
//   window.ziplineShowToast = function(message, isSuccess = true) {
//     const container = getOrCreateToastContainer();
//     const toast = document.createElement('div');
//     toast.className = 'zp-toast';
//     toast.setAttribute('style', [
//       'background: #182330',
//       'color: #FFFFFF',
//       'border-left: 4px solid ' + (isSuccess ? '#2E7D47' : '#D32F2F'),
//       'box-shadow: 0 10px 30px rgba(0,0,0,0.3)',
//       'padding: 14px 18px',
//       'border-radius: 8px',
//       'font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
//       'font-size: 14px',
//       'font-weight: 500',
//       'line-height: 1.5',
//       'display: flex',
//       'align-items: center',
//       'justify-content: space-between',
//       'gap: 12px',
//       'pointer-events: auto',
//       'transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1)',
//       'transform: translateY(20px)',
//       'opacity: 0'
//     ].join('; '));

//     toast.innerHTML = '<span>' + message + '</span><button type="button" style="background:none;border:none;color:#94A3B8;cursor:pointer;font-size:18px;padding:0;line-height:1;" aria-label="Close">&times;</button>';
    
//     const closeBtn = toast.querySelector('button');
//     closeBtn.addEventListener('click', function() {
//       toast.style.opacity = '0';
//       toast.style.transform = 'translateY(20px)';
//       setTimeout(() => toast.remove(), 300);
//     });

//     container.appendChild(toast);

//     requestAnimationFrame(() => {
//       toast.style.transform = 'translateY(0)';
//       toast.style.opacity = '1';
//     });

//     setTimeout(function() {
//       if (toast.parentElement) {
//         toast.style.opacity = '0';
//         toast.style.transform = 'translateY(20px)';
//         setTimeout(() => toast.remove(), 300);
//       }
//     }, 3500);
//   };

//   // 3. Update Cart Badges across Header
//   window.ziplineUpdateCartCount = function(count) {
//     const badges = document.querySelectorAll('.cart-count-bubble span, #cartCountBadge, [data-cart-count]');
//     badges.forEach(b => {
//       b.textContent = count;
//     });

//     const bubbles = document.querySelectorAll('.cart-count-bubble');
//     bubbles.forEach(b => {
//       if (count > 0) {
//         b.classList.remove('hidden');
//         b.style.display = 'flex';
//       }
//     });
//   };

//   // 4. Fresh Cart Drawer Fetch & Open (100% Reliable, Never Blank)
//   window.ziplineRefreshCartDrawer = function() {
//     const cartUrl = window.routes?.cart_url || '/cart';
//     fetch(cartUrl + '?section_id=cart-drawer')
//       .then(res => res.text())
//       .then(html => {
//         const parser = new DOMParser();
//         const doc = parser.parseFromString(html, 'text/html');
//         const newDrawer = doc.querySelector('cart-drawer');
//         const currentDrawer = document.querySelector('cart-drawer');

//         if (currentDrawer && newDrawer) {
//           currentDrawer.innerHTML = newDrawer.innerHTML;
//           currentDrawer.classList.remove('is-empty');
          
//           // Re-bind overlay close
//           const overlay = currentDrawer.querySelector('#CartDrawer-Overlay');
//           if (overlay) {
//             overlay.addEventListener('click', () => currentDrawer.close());
//           }

//           // Open drawer
//           if (typeof currentDrawer.open === 'function') {
//             currentDrawer.open();
//           } else {
//             currentDrawer.classList.add('active', 'animate');
//             document.body.classList.add('overflow-hidden');
//           }
//         }
//       })
//       .catch(err => {
//         console.error('Error refreshing cart drawer:', err);
//       });
//   };

//   // 5. Main Add to Cart Function
//   window.ziplineAddToCart = function(variantId, quantity, btnElement, productTitle) {
//     quantity = quantity || 1;
//     productTitle = productTitle || 'Item';

//     let origText = '';
//     if (btnElement) {
//       origText = btnElement.innerHTML;
//       btnElement.disabled = true;
//       btnElement.innerHTML = '<span>Adding...</span>';
//     }

//     function doActualAdd(vId) {
//       const payload = {
//         id: Number(vId),
//         quantity: Number(quantity),
//         sections: 'cart-drawer,cart-icon-bubble',
//         sections_url: window.location.pathname
//       };

//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json'
//         },
//         body: JSON.stringify(payload)
//       })
//       .then(function(res) {
//         if (!res.ok) {
//           return res.json().then(function(err) {
//             throw new Error(err.description || err.message || 'Could not add to cart');
//           });
//         }
//         return res.json();
//       })
//       .then(function(parsedState) {
//         if (btnElement) {
//           btnElement.innerHTML = '<span>Added ✓</span>';
//           setTimeout(function() {
//             btnElement.innerHTML = origText;
//             btnElement.disabled = false;
//           }, 1800);
//         }

//         window.ziplineShowToast('Added "' + (parsedState.title || productTitle) + '" to your bag! ✓', true);

//         // Render contents via Dawn cart-drawer if available
//         const currentDrawer = document.querySelector('cart-drawer');
//         if (currentDrawer && typeof currentDrawer.renderContents === 'function' && parsedState.sections) {
//           currentDrawer.renderContents(parsedState);
//         } else {
//           window.ziplineRefreshCartDrawer();
//         }

//         // Fetch fresh cart item count to ensure accurate badge
//         fetch('/cart.js')
//           .then(r => r.json())
//           .then(cart => {
//             if (cart && typeof cart.item_count === 'number') {
//               window.ziplineUpdateCartCount(cart.item_count);
//             }
//           })
//           .catch(function(){});
//       })
//       .catch(function(err) {
//         if (btnElement) {
//           btnElement.innerHTML = origText;
//           btnElement.disabled = false;
//         }
//         window.ziplineShowToast(err.message || 'Error adding to cart. Please try again.', false);
//       });
//     }

//     // If variantId is missing, try fetching from store products
//     if (!variantId || variantId === 'null' || variantId === 'undefined') {
//       fetch('/products.json?limit=5')
//         .then(r => r.json())
//         .then(data => {
//           let foundVarId = null;
//           if (data && data.products && data.products.length > 0) {
//             for (let i = 0; i < data.products.length; i++) {
//               const p = data.products[i];
//               if (p.variants && p.variants.length > 0) {
//                 const av = p.variants.find(v => v.available) || p.variants[0];
//                 if (av) {
//                   foundVarId = av.id;
//                   productTitle = p.title;
//                   break;
//                 }
//               }
//             }
//           }
//           if (foundVarId) {
//             doActualAdd(foundVarId);
//           } else {
//             // Fallback demo toast
//             if (btnElement) {
//               btnElement.innerHTML = '<span>Added ✓</span>';
//               setTimeout(function() {
//                 btnElement.innerHTML = origText;
//                 btnElement.disabled = false;
//               }, 1800);
//             }
//             window.ziplineShowToast('Added "' + productTitle + '" to your bag! ✓', true);
//             window.ziplineRefreshCartDrawer();
//           }
//         })
//         .catch(function() {
//           if (btnElement) {
//             btnElement.innerHTML = origText;
//             btnElement.disabled = false;
//           }
//         });
//       return;
//     }

//     doActualAdd(variantId);
//   };

//   // 6. Universal Card Variant Swatch Switcher (Home, Favorites, Collections)
//   window.ziplineSwitchCardSwatch = function(swatchEl, event) {
//     if (event) {
//       event.preventDefault();
//       event.stopPropagation();
//     }
//     if (!swatchEl) return;
//     const card = swatchEl.closest('.zp-card') || swatchEl.closest('.zp-product-card');
//     if (!card) return;

//     // Active swatch border
//     const swatches = card.querySelectorAll('.zp-card__swatch, .zp-swatch-btn');
//     swatches.forEach(s => s.classList.remove('is-active'));
//     swatchEl.classList.add('is-active');

//     // Add marker class to card to suppress secondary hover image
//     card.classList.add('has-swatch-selected');

//     // 1. Swap image smoothly
//     const imgUrl = swatchEl.getAttribute('data-img-url');
//     const primImg = card.querySelector('.zp-card__img--primary') || card.querySelector('.zp-product-card__img') || card.querySelector('img.zp-card__img');
//     const secImg = card.querySelector('.zp-card__img--secondary');

//     if (secImg) {
//       secImg.style.opacity = '0';
//       secImg.style.visibility = 'hidden';
//       secImg.style.pointerEvents = 'none';
//     }

//     if (imgUrl && primImg) {
//       primImg.style.transition = 'opacity 0.2s ease, transform 0.3s ease';
//       primImg.style.opacity = '0.4';
//       primImg.removeAttribute('srcset');
//       primImg.src = imgUrl;

//       primImg.onload = function() {
//         primImg.style.opacity = '1';
//       };
//       setTimeout(function() {
//         primImg.style.opacity = '1';
//       }, 250);
//     }

//     // 2. Update hidden variant ID
//     const varId = swatchEl.getAttribute('data-variant-id');
//     if (varId) {
//       const idInput = card.querySelector('input[name="id"]');
//       if (idInput) idInput.value = varId;

//       const buyBtn = card.querySelector('.zp-card__btn--buy') || card.querySelector('.zp-btn-card--buy');
//       if (buyBtn) {
//         buyBtn.href = '/cart/' + varId + ':1';
//       }

//       const cartBtn = card.querySelector('.zp-card__btn--cart') || card.querySelector('.zp-btn-card--cart');
//       if (cartBtn) {
//         cartBtn.setAttribute('data-variant-id', varId);
//       }
//     }

//     // 3. Update Price
//     const price = swatchEl.getAttribute('data-price');
//     if (price) {
//       const priceEl = card.querySelector('.zp-card__price-current') || card.querySelector('.zp-price-current');
//       if (priceEl) priceEl.textContent = price;
//     }

//     const compPrice = swatchEl.getAttribute('data-compare-price');
//     const compEl = card.querySelector('.zp-card__price-compare') || card.querySelector('.zp-price-original');
//     if (compEl) {
//       if (compPrice) {
//         compEl.textContent = compPrice;
//         compEl.style.display = 'inline-block';
//       } else {
//         compEl.style.display = 'none';
//       }
//     }

//     // 4. Update availability
//     const isAvail = swatchEl.getAttribute('data-available') !== 'false';
//     const cartBtn = card.querySelector('.zp-card__btn--cart') || card.querySelector('.zp-btn-card--cart');
//     if (cartBtn) {
//       if (!isAvail) {
//         cartBtn.textContent = 'Sold Out';
//         cartBtn.disabled = true;
//       } else {
//         cartBtn.textContent = 'Add To Cart';
//         cartBtn.disabled = false;
//       }
//     }
//   };

//   // 7. Delegated Global Event Listener for Swatches
//   document.addEventListener('click', function(e) {
//     const swatch = e.target.closest('.zp-card__swatch, .zp-swatch-btn');
//     if (swatch) {
//       window.ziplineSwitchCardSwatch(swatch, e);
//     }
//   });

//   document.addEventListener('mouseover', function(e) {
//     const swatch = e.target.closest('.zp-card__swatch, .zp-swatch-btn');
//     if (swatch && !swatch.classList.contains('is-active')) {
//       window.ziplineSwitchCardSwatch(swatch);
//     }
//   });

//   // 8. Global Form Handler
//   document.addEventListener('submit', function(e) {
//     const form = e.target;
//     if (form && (form.classList.contains('zp-card__form') || form.classList.contains('zp-pdp__form') || form.id === 'pdpForm')) {
//       e.preventDefault();
//       const variantInput = form.querySelector('[name="id"]');
//       const qtyInput = form.querySelector('[name="quantity"]');
//       const submitBtn = form.querySelector('button[type="submit"]') || form.querySelector('.zp-pdp__btn-cart') || form.querySelector('.zp-card__btn--cart');
      
//       const varId = variantInput ? variantInput.value : null;
//       const qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
      
//       let title = '';
//       const card = form.closest('.zp-card') || form.closest('.zp-pdp');
//       if (card) {
//         const titleEl = card.querySelector('.zp-card__title, .zp-pdp__title');
//         if (titleEl) title = titleEl.textContent.trim();
//       }

//       window.ziplineAddToCart(varId, qty, submitBtn, title);
//     }
//   });

// })();